module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-perfect-scrollbar', {
    ref: "scrollbar",
    class: _vm.scrollbarClasses,
    attrs: {
      "settings": _vm.perfectScrollbarOptions
    }
  }, [_c('div', {
    on: {
      "!dragstart": function($event) {
        _vm.onDragStart($event)
      },
      "!click": function($event) {
        _vm.onClick($event)
      },
      "mousedown": _vm.onMouseDown
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-877c0b94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/scroll-area/index.vue
// module id = 2070
// module chunks = 2